import { IConditionFlow, SceneType } from '@/interface';

enum ConditionType {
  DEFAULT = 0,
  // PASSMISSIONNUM = 1,
  PASS = 2, // SPECIFYMISSION
  TRAP = 3, // TRIGGERTRAP
};

enum NextAction {
  none = 0,
  filterJump = 1,
  initCond = 2,
  changeFixedCond = 3,
}

export interface IOption {
  value: string;
  label: string;
  disabled?: boolean;
  reason?: string;
  isCountDown?: boolean;
}

export interface ISpecifyMission {
  id: string;
  name: string;
  isError?: boolean;
}

export interface IRootNodeInfo {
  id: string;
  sceneId: string;
  sceneType: SceneType;
  conditions: IConditionFlow[];
  options: IOption[];
  isEmpty: boolean;
}

export { ConditionType, NextAction };
